import React, {HTMLAttributes, useMemo} from "react";
import ResponsivePicture from "@components/ResponsivePicture/ResponsivePicture";
import {NavLink} from "react-router-dom";
import {buildLinkUrl} from "@router/RouterUtils";
import {ChevronRightIcon} from "@components/Icons/ChevronRightIcon";
import {CmsBanner} from "@lib/Cms/CmsModels";
import {buildResponsiveImageArray} from "@commons/Utils";

export interface KvBannerProps extends HTMLAttributes<HTMLDivElement> {
    banner: CmsBanner;
    name: string;
    pushDown?: boolean;
    showContent?: boolean;
}

const KvBanner = ({banner, name, pushDown = false, showContent = true, ...divProps}: KvBannerProps) => {

    const hasContent = banner.cta && banner.cta.length > 0 || (banner.title || banner.subTitle);

    const images = useMemo(() => buildResponsiveImageArray(banner.image), [banner.image]);

    return (
        <div className={`kv ${hasContent && showContent ? "with-content" : "no-content"}`} {...divProps}>
            <ResponsivePicture
                alt=""
                className={"home-kv"}
                images={images}
            />
            {hasContent && showContent &&
                <div className={`kv__content ${pushDown ? "push-down" : ""}`}>
                    <div className="container">
                        <div className="kv__content__inner">

                            {!!banner.title &&
                                <h1 className={"tp-xl"} dangerouslySetInnerHTML={{__html: banner.title}}/>
                            }

                            {!!banner.subTitle &&
                                <h2 className={"tp-m light"} dangerouslySetInnerHTML={{__html: banner.subTitle}}/>
                            }

                            {!!banner.text &&
                                <h2 className={"tp-s light"} dangerouslySetInnerHTML={{__html: banner.text}}/>
                            }

                            {banner.cta && banner.cta.length > 0 &&
                                <div className={"kv__content__actions"}>
                                    {banner.cta.map((cta, index) =>
                                        <NavLink
                                            key={`banner_link_${name}_${index}`}
                                            to={buildLinkUrl(cta.scope)}
                                            className={`cta cta--${cta.size ?? "medium"} cta--${cta.color ?? "primary"} ${cta.options?.removeDefaultBorder ? "no-border" : ""}`}>
                                            <span className="label">{cta.title}</span>
                                            <span className="icon">
                                                <ChevronRightIcon/>
                                            </span>
                                        </NavLink>
                                    )}
                                </div>
                            }

                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default KvBanner;